import { render, staticRenderFns } from "./NuevoSucursal.vue?vue&type=template&id=49a5f2ce&"
import script from "./NuevoSucursal.vue?vue&type=script&lang=js&"
export * from "./NuevoSucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports